import { z } from 'zod';

import developmentConfig from '../config.development';
import e2eConfig from '../config.e2e';
import hotfixConfig from '../config.hotfix';
import productionConfig from '../config.production';
import qaConfig from '../config.qa';

export const config = z.object({
  serverUrl: z.string(),
  /**
   * Use proxy for development, if present.
   */
  proxyUrl: z.string().optional(),
  kikanUrl: z.string(),
  d2dFrontendZendeskUrl: z.string(),
  zendeskEnabled: z.boolean(),
  zendeskDashboard: z.string(),
  dev: z
    .object({
      serverUrl: z.string().optional(),
      accounts: z.array(
        z.object({
          tag: z.string(),
          email: z.string(),
          password: z.string(),
        }),
      ),
    })
    .optional(),
});

export type Config = z.infer<typeof config>;

export const getConfig = () => {
  let e: Config;

  if (process.env.VITE_APP_STAGE === 'production') {
    e = config.parse(productionConfig());
  } else if (process.env.VITE_APP_STAGE === 'e2e') {
    e = config.parse(e2eConfig());
  } else if (process.env.VITE_APP_STAGE === 'qa') {
    e = config.parse(qaConfig());
  } else if (process.env.VITE_APP_STAGE === 'hotfix') {
    e = config.parse(hotfixConfig());
  } else if (process.env.NODE_ENV === 'development' || process.env.VITE_APP_STAGE === 'staging') {
    e = config.parse(developmentConfig());
  } else {
    throw new Error(
      `Unknown NODE_ENV: ${process.env.NODE_ENV}, VITE_APP_STAGE: ${process.env.VITE_APP_STAGE}`,
    );
  }

  if (process.env.NODE_ENV === 'development') {
    if (e.dev?.serverUrl) {
      // Sorry, but config.serverUrl is used everywhere, so we simply overwrite serverUrl to
      // make all requests use proxy.
      e.serverUrl = e.dev.serverUrl;
      console.info(`Using dev.serverUrl ${e.dev.serverUrl} for development.`);
    }
  }
  return e;
};
